import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initServiceWorker } from './pwa/registerSW';
import './styles/base.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Registered after the first render so the service worker never competes with
 * the initial paint for bandwidth on shop wifi.
 */
initServiceWorker();
